"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CreateFiatWithdraw = void 0;
var _react = _interopRequireDefault(require("react"));
var _state = require("../../../../../../state");
var _Context = require("./Context");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var CreateFiatWithdraw = function CreateFiatWithdraw(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/_react.default.createElement(_Context.Context.Provider, {
    value: {
      useCreateWithdraw: _state.useCreateFiatWithdraw,
      useWithdrawFee: _state.useFiatWithdrawFee
    }
  }, children);
};
exports.CreateFiatWithdraw = CreateFiatWithdraw;